import styled from "styled-components";

export const DescriptionPros = styled.div`
	border-radius: 15px;
	height: calc(100% - 130px);
	overflow-y: auto;
	display: flex;
	flex-direction: column;
	padding: 0px 15px;
	background: #fffdfd;
	border-top-left-radius: 0;
	border-top-right-radius: 0;
	border-top: 1px solid #c2c2c2;
	span {
		font-size: 0.8em;
		margin: 0;
		padding: 10px 0 0px;
	}
`;
